/* ============================================================
   BALCOUR.DK — Cart Drawer JavaScript
   Custom built for Balcour theme
   ============================================================ */

(function () {
  'use strict';

  // ---- Config ----
  const CART_LOC = (document.documentElement.lang || '').toLowerCase().slice(0,2);
const CART_IS_EN = CART_LOC === 'en';
const CART_IS_NL = CART_LOC === 'nl';
const FREE_SHIPPING_THRESHOLD = (CART_IS_EN || CART_IS_NL) ? (67 * 100) : (500 * 100); // 67 EUR / 500 DKK in cents
  const CART_IS_EUR = (CART_IS_EN || CART_IS_NL);
  const CART_CURRENCY = ((typeof window !== 'undefined' && window.BALCOUR_CURRENCY) ? String(window.BALCOUR_CURRENCY) : (CART_IS_EUR ? 'EUR' : 'DKK')).toUpperCase();
const CURRENCY_SYMBOL = CART_IS_EUR ? '\u20ac' : 'kr.';

  // Wait for DOM ready
  function init() {
    const drawer       = document.getElementById('cart-drawer');
    const overlay      = document.getElementById('cart-drawer-overlay');
    const closeBtn     = document.getElementById('cart-drawer-close');
    const countEl      = document.getElementById('cart-drawer-count');
    const itemsEl      = document.getElementById('cart-drawer-items');
    const emptyEl      = document.getElementById('cart-drawer-empty');
    const footerEl     = document.getElementById('cart-drawer-footer');
    const subtotalEl        = document.getElementById('cart-subtotal-price');
    const compareSubtotalEl = document.getElementById('cart-subtotal-compare');
    const loadingEl    = document.getElementById('cart-drawer-loading');
    const shippingText = document.getElementById('cart-shipping-text');
    const shippingFill = document.getElementById('cart-shipping-fill');
    const continueBtn  = null; // removed — replaced by payment icons
    const emptyCta     = document.getElementById('cart-drawer-continue');
    const noteToggle   = document.getElementById('cart-note-toggle');
    const noteBody     = document.getElementById('cart-note-body');
    const noteInput    = document.getElementById('cart-note-input');

    if (!drawer) {
      console.warn('[BalcourCart] #cart-drawer not found in DOM');
      return;
    }

    let cartData  = null;
    let noteTimer = null;
    let hasRendered = false; // Track if we've rendered before (skip animation on re-render)
    let atcInProgress = false; // Mutex: prevent double addToCart

    // ---- Helpers ----
    function formatMoney(cents) {
      const amount = (cents / 100).toLocaleString(CART_IS_NL ? 'nl-NL' : (CART_IS_EN ? 'en-IE' : 'da-DK'), {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      if (CART_CURRENCY === 'EUR') return `${CURRENCY_SYMBOL}${amount}`;
      if (CART_CURRENCY === 'SEK') return `${amount} SEK`;
      return `${amount} kr.`;
    }

    function setLoading(visible) {
      if (!loadingEl) return;
      loadingEl.classList.toggle('is-visible', visible);
      loadingEl.setAttribute('aria-hidden', String(!visible));
    }

    function clearAtcLoading() {
      document.querySelectorAll('.atc-spinner').forEach(function(sp) { sp.remove(); });
      document.querySelectorAll('.is-atc-loading, .is-loading, .btn-loading').forEach(function(btn) {
        btn.classList.remove('is-atc-loading', 'is-loading', 'btn-loading');
      });
    }

    function bumpCount() {
      if (!countEl) return;
      countEl.classList.remove('bump');
      void countEl.offsetWidth;
      countEl.classList.add('bump');
      setTimeout(() => countEl.classList.remove('bump'), 300);
    }

    // ---- Open / Close ----
    function openDrawer(skipRefresh) {
      // Close existing drawer if open
      var themeDrawer = document.getElementById('CartDrawer');
      if (themeDrawer && themeDrawer.classList.contains('drawer--is-open')) {
        document.body.classList.remove('js-drawer-open');
        themeDrawer.classList.remove('drawer--is-open');
      }

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-active');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
      // Show cached cart data instantly
      if (cartData) renderCart(cartData);
      // Only fetch fresh data if not handled by caller (e.g. addToCart)
      if (!skipRefresh) fetchCart();
    }

    function closeDrawer() {
      clearAtcLoading();
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-active');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function isOpen() {
      return drawer.classList.contains('is-open');
    }

    // ---- API calls ----
    async function fetchCart() {
      try {
        const res = await fetch('/cart.js', {
          headers: { 'Content-Type': 'application/json' },
        });
        cartData = await res.json();
        renderCart(cartData);
      } catch (err) {
        console.error('[BalcourCart] fetchCart failed:', err);
      }
    }

    async function updateItemQty(key, quantity) {
      setLoading(true);
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        cartData = await res.json();
        renderCart(cartData);
      } catch (err) {
        console.error('[BalcourCart] updateItemQty failed:', err);
      } finally {
        setLoading(false);
      }
    }

    async function removeItem(key, itemEl) {
      if (itemEl) itemEl.classList.add('is-removing');
      await new Promise(r => setTimeout(r, 250));
      await updateItemQty(key, 0);
    }

    async function addToCart(variantId, quantity, properties) {
      if (atcInProgress) return;
      atcInProgress = true;
      quantity = quantity || 1;
      properties = properties || {};
      try {
        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties }),
          _balcour: true,
        });
        if (!addRes.ok) throw new Error('Add to cart failed: ' + addRes.status);
        var cartRes = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' }, _balcour: true });
        cartData = await cartRes.json();
        renderCart(cartData);
        clearAtcLoading();
        openDrawer(true);
        fetchCompareAtPrices(cartData.items);
      } catch (err) {
        console.error('[BalcourCart] addToCart failed:', err);
        clearAtcLoading();
      } finally {
        atcInProgress = false;
      }
    }

    async function saveNote(note) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note }),
        });
      } catch (err) {
        console.error('[BalcourCart] saveNote failed:', err);
      }
    }

    // ---- Compare-at price cache ----
    var compareAtCache = {}; // variant_id → compare_at_price (cents)

    async function fetchCompareAtPrices(items) {
      var handles = [];
      items.forEach(function(item) {
        if (!(item.variant_id in compareAtCache) && handles.indexOf(item.handle) === -1) {
          handles.push(item.handle);
        }
      });
      if (handles.length === 0) return;
      await Promise.all(handles.map(async function(h) {
        try {
          var res = await fetch('/products/' + h + '.js');
          var prod = await res.json();
          prod.variants.forEach(function(v) {
            compareAtCache[v.id] = v.compare_at_price; // cents or null
          });
        } catch(e) {}
      }));
    }

    function updateCompareSubtotal(cart) {
      if (!compareSubtotalEl) return;
      var compareTotal = 0;
      cart.items.forEach(function(item) {
        var cap = compareAtCache[item.variant_id] || null;
        var compareLine = (cap && cap > 0) ? cap * item.quantity : 0;
        if (compareLine <= item.final_line_price) compareLine = item.original_line_price;
        compareTotal += (compareLine > item.final_line_price ? compareLine : item.final_line_price);
      });
      if (compareTotal > cart.total_price) {
        compareSubtotalEl.textContent = formatMoney(compareTotal);
        compareSubtotalEl.style.display = '';
      } else {
        compareSubtotalEl.style.display = 'none';
      }
    }

    // ---- Render ----
    async function renderCart(cart) {
      var count = cart.item_count;

      // Update our count badge
      if (countEl) {
        countEl.textContent = count;
        bumpCount();
      }

      // Also update cart bubble
      document.querySelectorAll('.cart-link__bubble').forEach(function(el) {
        if (count > 0) {
          el.classList.add('cart-link__bubble--visible');
        } else {
          el.classList.remove('cart-link__bubble--visible');
        }
      });

      // Shipping bar
      renderShippingBar(cart.total_price);

      if (count === 0) {
        if (emptyEl) emptyEl.style.display = 'flex';
        if (itemsEl) itemsEl.style.display = 'none';
        if (footerEl) footerEl.style.display = 'none';
      } else {
        // Render items IMMEDIATELY with whatever compare-at data we have cached
        if (emptyEl) emptyEl.style.display = 'none';
        if (itemsEl) {
          itemsEl.style.display = 'block';
          var skipAnim = hasRendered;
          itemsEl.innerHTML = cart.items.map(function(item) { return renderItem(item, skipAnim); }).join('');
          bindItemEvents();
          hasRendered = true;
        }
        if (footerEl) footerEl.style.display = 'block';
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        updateCompareSubtotal(cart);
        if (cart.note && noteInput) noteInput.value = cart.note;

        // Then fetch compare-at prices in background and update if needed
        fetchCompareAtPrices(cart.items).then(function() {
          updateCompareSubtotal(cart);
          if (!itemsEl) return;
          // Re-render only if we got new compare-at data
          var newHtml = cart.items.map(function(item) { return renderItem(item, true); }).join('');
          if (itemsEl.innerHTML !== newHtml) {
            itemsEl.innerHTML = newHtml;
            bindItemEvents();
          }
        });
      }
    }

    function renderItem(item, skipAnim) {
      // Determine the best compare (strikethrough) price:
      // 1. Use variant compare_at_price × qty if available and higher than final_line_price
      // 2. Fall back to original_line_price if it's higher than final_line_price (automatic discounts)
      var compareAtPrice = compareAtCache[item.variant_id] || null;
      var compareLine = 0;
      if (compareAtPrice && compareAtPrice > 0) {
        compareLine = compareAtPrice * item.quantity;
      }
      if (compareLine <= item.final_line_price) {
        // Fall back to original_line_price (handles automatic discounts without compare_at)
        compareLine = item.original_line_price;
      }
      var hasCompare = compareLine > item.final_line_price;

      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      var comparePrice = hasCompare
        ? '<span class="cart-item__price-compare">' + formatMoney(compareLine) + '</span>'
        : '';
      var imgSrc = item.image
        ? item.image.replace(/(\.[^.]+)$/, '_120x120$1')
        : null;
      var imgHTML = imgSrc
        ? '<img class="cart-item__image" src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '" loading="eager" width="80" height="80">'
        : '<div class="cart-item__image-placeholder"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';

      var animClass = skipAnim ? ' no-anim' : '';
      return '<div class="cart-item' + animClass + '" data-key="' + item.key + '">' +
        '<div class="cart-item__image-wrap">' + imgHTML + '</div>' +
        '<div class="cart-item__info">' +
          '<div>' +
            '<div class="cart-item__top">' +
              '<p class="cart-item__title" style="text-transform:uppercase">' + escapeHtml(item.product_title) + '</p>' +
              '<button class="cart-item__remove" aria-label="Fjern ' + escapeHtml(item.product_title) + '" data-key="' + item.key + '">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
              '</button>' +
            '</div>' +
            variantTitle +
          '</div>' +
          '<div class="cart-item__bottom">' +
            '<div class="cart-item__price-wrap">' +
              '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
              comparePrice +
            '</div>' +
            '<div class="cart-item__qty">' +
              '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-action="decrease" aria-label="Reducer antal"' + (item.quantity <= 1 ? ' disabled' : '') + '>' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>' +
              '<span class="cart-item__qty-num" aria-live="polite">' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-action="increase" aria-label="&Oslash;g antal">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    function renderShippingBar(totalPrice) {
      if (!shippingText || !shippingFill) return;
      var pct = Math.min((totalPrice / FREE_SHIPPING_THRESHOLD) * 100, 100);
      shippingFill.style.width = pct + '%';

      if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
        shippingFill.classList.add('is-complete');
        shippingText.innerHTML = CART_IS_NL ? '<span class="cd-free">Je hebt gratis verzending!</span>' : (CART_IS_EN ? '<span class="cd-free">You have free shipping!</span>' : '<span class="cd-free">Du har gratis fragt!</span>');
      } else {
        shippingFill.classList.remove('is-complete');
        var remaining = formatMoney(FREE_SHIPPING_THRESHOLD - totalPrice);
        shippingText.innerHTML = CART_IS_NL ? ('Besteed <strong>' + remaining + '</strong> meer voor gratis verzending') : (CART_IS_EN ? ('Spend <strong>' + remaining + '</strong> more for free shipping') : ('K&oslash;b for <strong>' + remaining + '</strong> mere og f&aring; gratis fragt'));
      }
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    // ---- Event Binding ----
    function bindItemEvents() {
      if (!itemsEl) return;
      itemsEl.querySelectorAll('.cart-item__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', async function() {
          var key    = btn.dataset.key;
          var action = btn.dataset.action;
          var item   = cartData ? cartData.items.find(function(i) { return i.key === key; }) : null;
          if (!item) return;
          var newQty = action === 'increase' ? item.quantity + 1 : item.quantity - 1;
          if (newQty < 1) return;
          await updateItemQty(key, newQty);
        });
      });

      itemsEl.querySelectorAll('.cart-item__remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key    = btn.dataset.key;
          var el     = btn.closest('.cart-item');
          removeItem(key, el);
        });
      });
    }

    // ---- Note Toggle ----
    if (noteToggle && noteBody) {
      noteToggle.addEventListener('click', function() {
        var open = noteBody.classList.toggle('is-open');
        noteToggle.classList.toggle('is-open', open);
        if (open && noteInput) noteInput.focus();
      });
    }

    if (noteInput) {
      noteInput.addEventListener('input', function() {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function() { saveNote(noteInput.value); }, 800);
      });
    }

    // ---- Close listeners ----
    if (closeBtn)    closeBtn.addEventListener('click', closeDrawer);
    if (overlay)     overlay.addEventListener('click', closeDrawer);
    if (continueBtn) continueBtn.addEventListener('click', closeDrawer);
    if (emptyCta)    emptyCta.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen()) closeDrawer();
    });

    // Focus trap
    drawer.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab' || !isOpen()) return;
      var focusable = drawer.querySelectorAll(
        'button:not([disabled]), a[href], textarea, input, [tabindex]:not([tabindex="-1"])'
      );
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });

    // ===========================================================
    // BALCOUR THEME INTEGRATION
    // ===========================================================

    // 1) Cart icon click, /cart links, and ATC buttons
    document.addEventListener('click', function(e) {
      // Our own trigger
      var customTrigger = e.target.closest('[data-cart-drawer-open]');
      if (customTrigger) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
        return;
      }

      // ATC button — add spinner + call addToCart directly from form data
      var atcBtn = e.target.closest('[data-add-to-cart], button.add-to-cart, .add-to-cart');
      if (atcBtn) {
        var form = atcBtn.closest('form[action*="/cart/add"]');
        if (!form) return; // Bundle/custom JS — let fetch interceptor handle it
        var fd = new FormData(form);
        var id = fd.get('id');
        if (!id) return; // No variant id — bail out, don't block default
        e.preventDefault();
        e.stopPropagation();
        var qty = parseInt(fd.get('quantity') || '1', 10);
        var props = {};
        fd.forEach(function(val, key) {
          if (key.startsWith('properties[')) {
            props[key.replace(/^properties\[(.+)\]$/, '$1')] = val;
          }
        });
        atcBtn.classList.add('is-atc-loading');
        var sp = document.createElement('span');
        sp.className = 'atc-spinner';
        atcBtn.appendChild(sp);
        setTimeout(clearAtcLoading, 3000); // Safety fallback
        addToCart(id, qty, props);
        return;
      }

      // Theme cart button
      var themeCartBtn = e.target.closest('.js-drawer-open-cart');
      if (themeCartBtn) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
        return;
      }

      // Any link to /cart (but not /cart/checkout etc)
      var link = e.target.closest('a[href="/cart"]');
      if (link) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
        return;
      }
    }, true); // useCapture: intercept before default handlers

    // 2) Intercept ATC form submissions
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action="/cart/add"], form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var fd = new FormData(form);
      var id = fd.get('id');
      var qty = parseInt(fd.get('quantity') || '1', 10);
      var properties = {};
      fd.forEach(function(val, key) {
        if (key.startsWith('properties[')) {
          var propKey = key.replace(/^properties\[(.+)\]$/, '$1');
          properties[propKey] = val;
        }
      });
      if (id) {
        addToCart(id, qty, properties);
      }
    }, true); // <-- useCapture: true

    // 3) Intercept AJAX cart calls
    //    Override native fetch to intercept /cart/add.js calls
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
      var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');

      // Only intercept if it's NOT from our own code
      if (urlStr.indexOf('/cart/add') !== -1 && options && options._balcour !== true && !atcInProgress) {
        return originalFetch.apply(this, arguments).then(function(response) {
          if (response.ok) {
            fetch('/cart.js', { _balcour: true })
              .then(function(r) { return r.json(); })
              .then(function(cart) { cartData = cart; fetchCompareAtPrices(cart.items); renderCart(cart); clearAtcLoading(); openDrawer(true); });
          }
          return response;
        });
      }

      return originalFetch.apply(this, arguments);
    };

    // Also patch jQuery AJAX if jQuery is loaded
    if (window.jQuery) {
      var origAjax = jQuery.ajax;
      jQuery.ajax = function(urlOrSettings, settings) {
        var opts = typeof urlOrSettings === 'string'
          ? Object.assign({ url: urlOrSettings }, settings || {})
          : urlOrSettings;

        if (opts.url && opts.url.indexOf('/cart/add') !== -1) {
          var origSuccess = opts.success;
          opts.success = function() {
            if (origSuccess) origSuccess.apply(this, arguments);
            fetch('/cart.js', { _balcour: true })
              .then(function(r) { return r.json(); })
              .then(function(cart) { cartData = cart; fetchCompareAtPrices(cart.items); renderCart(cart); clearAtcLoading(); openDrawer(true); });
          };
        }

        return origAjax.call(this, opts);
      };
    }

    // 4) Mark our own fetch calls so we don't intercept them
    var _origFetchRef = originalFetch;
    // Override our internal calls to use the _balcour flag
    // (already handled above - our addToCart/fetchCart use the patched fetch,
    //  but won't trigger re-open because they use /cart.js and /cart/change.js)

    // ---- Expose public API ----
    window.BalcourCart = {
      open:    openDrawer,
      close:   closeDrawer,
      add:     addToCart,
      refresh: fetchCart,
    };

    // ---- Init: load cart count on page load + pre-warm compare-at cache ----
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count;
        if (countEl) countEl.textContent = count;
        cartData = cart;
        // Pre-fetch compare-at prices so they're cached when drawer opens
        if (cart.items && cart.items.length > 0) {
          fetchCompareAtPrices(cart.items);
        }
      })
      .catch(function() {});
  }

  // Run init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// ---- Price Row: build dynamically from theme data ----
(function() {
  function bcFormatPrice(cents) {
    if (CART_CURRENCY === 'EUR') return '\u20ac' + Math.floor(cents / 100);
    if (CART_CURRENCY === 'SEK') return Math.floor(cents / 100) + ' SEK';
    return Math.floor(cents / 100) + ',-';
  }

  function buildPriceRow() {
    var block = document.querySelector('.product-block--price');
    if (!block) return;
    // Force padding
    block.style.cssText += 'padding-top:0!important;margin-top:-10px!important;';
    if (block.querySelector('.bc-price-row')) return;

    // Read prices from existing theme elements
    var priceEl = block.querySelector('[data-product-price]');
    var compareEl = block.querySelector('[data-compare-price]');
    if (!priceEl) return;

    // Get raw cents from the product JSON on page
    var productJson = document.querySelector('[data-product-json]');
    var price = 0, compare = 0;
    if (productJson) {
      try {
        var pData = JSON.parse(productJson.textContent);
        var v = pData.current_variant || pData.variants[0];
        price = v.price;
        compare = v.compare_at_price || 0;
      } catch(e) {}
    }

    // Fallback: parse from text
    if (!price) {
      var pText = priceEl.textContent.replace(/[^\d.,]/g, '').replace('.', '').replace(',', '.');
      price = Math.round(parseFloat(pText) * 100) || 0;
    }
    if (!compare && compareEl) {
      var cText = compareEl.textContent.replace(/[^\d.,]/g, '').replace('.', '').replace(',', '.');
      compare = Math.round(parseFloat(cText) * 100) || 0;
    }

    // Build new row
    var row = document.createElement('div');
    row.className = 'bc-price-row';
    row.setAttribute('data-bc-price-row', '');

    var nowSpan = document.createElement('span');
    nowSpan.className = 'bc-price-now';
    nowSpan.textContent = bcFormatPrice(price);
    row.appendChild(nowSpan);

    if (compare && compare > price) {
      var oldSpan = document.createElement('span');
      oldSpan.className = 'bc-price-old';
      oldSpan.textContent = bcFormatPrice(compare);
      row.appendChild(oldSpan);

      var badge = document.createElement('span');
      badge.className = 'bc-price-badge';
      badge.textContent = (CART_IS_EN || CART_IS_NL) ? ('-€' + Math.floor((compare - price) / 100)) : ('Spar ' + Math.floor((compare - price) / 100) + ' kr.');
      row.appendChild(badge);
    }

    // Insert at top of price block
    block.insertBefore(row, block.firstChild);
  }

  function updatePriceBadge(variant) {
    var row = document.querySelector('[data-bc-price-row]');
    if (!row) return;
    var nowEl = row.querySelector('.bc-price-now');
    if (!nowEl) return;

    nowEl.textContent = bcFormatPrice(variant.price);

    var oldEl = row.querySelector('.bc-price-old');
    var badgeEl = row.querySelector('.bc-price-badge');

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (!oldEl) {
        oldEl = document.createElement('span');
        oldEl.className = 'bc-price-old';
        row.insertBefore(oldEl, nowEl.nextSibling);
      }
      oldEl.textContent = bcFormatPrice(variant.compare_at_price);
      oldEl.style.display = '';

      if (!badgeEl) {
        badgeEl = document.createElement('span');
        badgeEl.className = 'bc-price-badge';
        row.appendChild(badgeEl);
      }
      var saving = Math.floor((variant.compare_at_price - variant.price) / 100);
      badgeEl.textContent = (CART_IS_EN || CART_IS_NL) ? ('-€' + saving) : ('Spar ' + saving + ' kr.');
      badgeEl.style.display = '';
    } else {
      if (oldEl) oldEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
    }
  }

  // Build on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildPriceRow);
  } else {
    buildPriceRow();
  }

  // Update on variant change
  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) updatePriceBadge(e.detail.variant);
  });
  document.addEventListener('variantPriceChange', function(e) {
    if (e.detail && e.detail.variant) updatePriceBadge(e.detail.variant);
  });
})();
